import { Transform } from 'class-transformer';

// Отсутствующее значение не оборачивается: [undefined] прошёл бы проверку необязательного поля как массив
// и валил бы проверку его элементов.
const wrapToArray = Transform(({ value })=>value === undefined || value === null || Array.isArray(value) ? value : [
        value
    ]);

export { wrapToArray as w };
//# sourceMappingURL=wrapToArray_chunkExport-DCCOllzb.mjs.map
